import { msalService } from '@base/services/msal'

export const initializeMsalAuth = (environmentGetter: (env: string) => any) => {
  const config = useRuntimeConfig()
  const { APP_ENV = 'development' } = config.public as { APP_ENV?: string }
  const environment = environmentGetter(APP_ENV)

  if (!environment.msal) {
    throw new Error('Msal configuration is missing')
  }

  return msalService(environment.msal)
}
